import { sample } from 'effector';
import $$api from 'models/api';
import { $isValidationPage, $pathname } from 'models/location';
import $$validation from 'models/pages/validation';
import { $global } from 'models/store-global';

import { createTunnel } from 'utils/factories/create-tunnel';

import { DocumentStatusType } from 'types/zod/document-status-type';

sample({
    source: createTunnel($global, (state) => state?.auth?.isAuthenticated === true),
    target: $$validation.$isAuthorized,
});

sample({
    source: {
        isValidationPage: $isValidationPage,
        guid: $pathname.map((pathname) => pathname.split('/')?.[2] || null),
    },
    fn: ({ isValidationPage, guid }) => (isValidationPage ? guid : null),
    target: $$validation.$guid,
});

sample({
    source: $$validation.$guid,
    filter: (guid): guid is DocumentStatusType => guid !== null,
    target: $$api.documents.getDocumentValidityFx,
});

sample({
    source: $$api.documents.getDocumentValidityFx.pending,
    target: $$validation.$loading,
});

sample({
    source: $$api.documents.getDocumentValidityFx.finally,
    fn: (params) => (params.status === 'done' ? (params.result.status === 'Revoked' ? 'invalid' : 'success') : 'error'),
    target: $$validation.$validationResult,
});

sample({
    source: $$api.documents.getDocumentValidityFx.failData.map(() => null),
    target: $$validation.$document,
});

sample({
    source: $$api.documents.getDocumentValidityFx.doneData,
    target: $$validation.$document,
});
